import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface RolesState {
  rolesList: any
  permissionList: any
  rolesAndPermissionList: any[]
  rolesAndPermissionEdit: any
  rolesAndPermissionUpdate: any
  revokeRole: any
  rolesError: any
  permissionGroups: any
  permission: any
  group: any
  success: any
  successRole: any
  error: any
  roleDetails: any
}

export const useRolesStore = defineStore('roles', {
  state: (): RolesState => ({
    rolesList: null,
    permissionList: null,
    rolesAndPermissionList: [],
    rolesAndPermissionEdit: null,
    rolesAndPermissionUpdate: null,
    revokeRole: null,
    rolesError: null,
    permissionGroups: null,
    permission: null,
    group: null,
    success: null,
    successRole: null,
    error: null,
    roleDetails: null,
  }),

  getters: {
    getRolesList: (state) => state.rolesList,
    getRoleDetails: (state) => state.roleDetails,
    getNewRole: (state) => state.successRole,
    getNewRoleError: (state) => state.error,
    getPermissionList: (state) => state.permissionList,
    getPermissionGroupsList: (state) => state.permissionGroups,
    getRolesAndPermissionEdit: (state) => state.rolesAndPermissionEdit,
    getRolesAndPermissionUpdate: (state) => state.rolesAndPermissionUpdate,
    getRolesError: (state) => state.rolesError,
    getRoleRemovalSuccess: (state) => state.revokeRole,
    getNewPermission: (state) => state.permission,
    getNewPermissionGroup: (state) => state.group,
  },

  actions: {
    async saveNewRole(data: any) {
      try {
        const response = await api().post('auth/api/roles', data)
        this.successRole = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async addPermission(data: any) {
      try {
        const response = await api().post('auth/api/permissions', data)
        this.permission = response.data
      } catch (error: any) {
        this.rolesError = error.response?.data
      }
    },

    async addPermissionGroup(data: any) {
      try {
        const response = await api().post('auth/api/permission-group', data)
        this.group = response.data
      } catch (error: any) {
        this.rolesError = error.response?.data
      }
    },

    async updateRoleAndPermission(data: any) {
      try {
        const response = await api().put('auth/api/roles/update', data)
        this.rolesAndPermissionUpdate = response.data
      } catch (error: any) {
        this.rolesError = error.response?.data
      }
    },

    async fetchPermissions() {
      try {
        const response = await api().get('auth/api/permissions')
        this.permissionList = response.data
      } catch (error: any) {
        this.rolesError = error.response?.data
      }
    },

    async fetchPermissionGroups() {
      try {
        const response = await api().get('auth/api/permission-group')
        this.permissionGroups = response.data
      } catch (error: any) {
        this.rolesError = error.response?.data
      }
    },

    async fetchRoles() {
      try {
        const response = await api().get('auth/api/roles')
        this.rolesList = response.data
      } catch (error: any) {
        this.rolesError = error.response?.data
      }
    },

    async fetchRoleDetails(roleId: string | number) {
      try {
        const response = await api().get('auth/api/roles/' + roleId)
        this.roleDetails = response.data
      } catch (error: any) {
        this.rolesError = error.response?.data
      }
    },

    async assignRole(data: any) {
      try {
        const response = await api().post('auth/api/roles/to-user', data)
        this.successRole = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async removeUserRole(data: any) {
      try {
        const response = await api().post('auth/api/roles/from-user', data)
        this.revokeRole = response.data
      } catch (error: any) {
        this.rolesError = error.response?.data
      }
    },
  },
})
